import React from 'react'
import {useDispatch} from 'react-redux'
import {actions} from './redux/LeadStatusRedux'
import {LeadStatusModel} from './models/LeadStatusModel'

type Props = {
  leadStatus: LeadStatusModel
  index: string
}

const LeadStatusRow: React.FC<Props> = ({leadStatus, index}) => {
  const dispatch = useDispatch()

  const deleteStatus = () => {
    if (window.confirm('Are you sure you want to delete this lead status?')) {
      dispatch(actions.deleteLeadStatus(leadStatus.id))
    }
  }

  return (
    <tr key={`row-${index}`}>
      <td className='text-dark fw-bolder text-hover-primary fs-6'>{leadStatus.status}</td>
      <td className='text-end'>
        <a
          href='#'
          className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
          onClick={deleteStatus}
        >
          <i className='bi bi-trash-fill fs-4'></i>
        </a>
      </td>
    </tr>
  )
}

export default LeadStatusRow
